export const APP_NAME = 'Grana Money';
export const SUPPORT_EMAIL = 'suporte@granamoney.app';
export const QUERY_STALE_TIME = 30_000;
export const QUERY_GC_TIME = 5 * 60_000;

export const NOTIFICATION_TYPES = [
  'due_date_reminder',
  'goal_reached',
  'budget_exceeded',
  'system',
  'family_invite',
  'platform',
  'family_group_settlement_created',
  'family_group_settlement_deleted',
  'family_group_contribution_updated',
  'family_group_member_force_removed',
] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];
